
<template>
  <div class="outmain ba_f">
    <div class="shuju_title mar_b20">
      <div class="shuju_title_text">
        <span>骑手单量排行�</span>
      </div>
    </div>
    <div class="flex mar_t20 mar_b20">
      <el-form :inline="true" :model="params" class="demo-form-inline searchform" size="mini">
        <el-form-item>
          <el-button type="primary" size="mini" plain :class="{ bgColor: timeType == 1 }" @click="changeType(1)">今日</el-button>
          <el-button type="primary" size="mini" plain :class="{ bgColor: timeType == 2 }" @click="changeType(2)">昨日</el-button>
          <el-button type="primary" size="mini" plain :class="{ bgColor: timeType == 3 }" @click="changeType(3)">本周</el-button>
          <el-button type="primary" size="mini" plain :class="{ bgColor: timeType == 4 }" @click="changeType(4)">本月</el-button>
          <el-button type="primary" size="mini" plain :class="{ bgColor: timeType == 5 }" @click="changeType(5)">季度</el-button>
          <el-button type="primary" size="mini" plain :class="{ bgColor: timeType == 6 }" @click="changeType(6)">本年</el-button>
        </el-form-item>
        <el-form-item :label="$t('common.startDate')" class="mar_l20">
          <div class="flex-start">
            <el-date-picker value-format="timestamp" v-model="timeData" type="daterange" :range-separator="$t('common.to')" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')" @change="changeTime"></el-date-picker>
            <el-button class="mar_l20" type="primary" @click="onScreen">{{ $t('common.filter') }}</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <el-table v-loading="listLoading" :element-loading-text="loadingText" :data="list" stripe style="width: 100%" @selection-change="setSelectRows">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="排名">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column prop="userName" label="骑手姓名"></el-table-column>
      <el-table-column prop="count" :label="$t('common.status')"</el-table-column>
      <el-table-column prop="money" :label="$t('common.status')"</el-table-column>
    </el-table>
    <el-pagination background layout="prev, pager, next" :total="total" :page-size="size" :current-page="params.page" @current-change="handleCurrentChange"></el-pagination>
  </div>
</template>
<script>
import { rankingList } from '@/api/plugins';
export default {
  data() {
    return {
      activeName: '1',
      list: [],
      listLoading: false,
      
      params: {
        page: 1,
        type: 1,
        startTime: '',
        endTime: ''
      },
      timeData: [],
      total: 0,
      size: 10
    };
  },
  computed: {
    loadingText() {
      return this.$t('common.loading');
    },
    timeType() {
      return this.params.type;
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    // 分页
    handleCurrentChange(val) {
      this.params.page = val;
      this.fetchData();
    },
    // 时间段选择
    changeTime(msg) {
      this.params.startTime = msg[0] / 1000;
      this.params.endTime = msg[1] / 1000;
    },
    // 时间类型选择
    changeType(msg) {
      this.params.type = msg;
      this.fetchData();
    },
    // 获取排行榜列�?
    fetchData() {
      rankingList(this.params).then((res) => {
        if (res.code == 1) {
          this.list = res.data;
          this.total = res.count;
          this.listLoading = false;
        }
      });
    },
    onScreen() {
      this.params.type = 0;
      this.fetchData();
    },
    handleEdit() {},
    setSelectRows() {}
  }
};
</script>
<style lang="stylus" scoped>
.bgColor {
  color: #FFF;
  background-color: #2A75ED;
  border-color: #2A75ED;
}
</style>